import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  NavController,
  IonHeader,
  IonToolbar,
  IonContent,
  IonTitle,
  IonFab,
  IonFabButton,
  IonIcon,
  IonSkeletonText,
  IonButton,
} from '@ionic/angular/standalone';
import { RouterModule } from '@angular/router';
import { StoriesService } from 'src/app/features/stories/stories.service';
import { Story } from 'src/app/features/stories/types/story';
import { StorySigilComponent } from 'src/app/features/stories/components/story-sigil/story-sigil.component';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';

@Component({
  selector: 're-stories',
  templateUrl: './stories.page.html',
  styleUrls: ['./stories.page.scss'],
  imports: [
    IonSkeletonText,
    IonIcon,
    IonButton,
    CommonModule,
    FormsModule,
    RouterModule,
    IonHeader,
    IonToolbar,
    IonContent,
    IonTitle,
    IonFab,
    IonFabButton,
    IonIcon,
    StorySigilComponent,
    ...TRANSLATE_IMPORTS,
  ],
})
export class StoriesPage {
  navController = inject(NavController);
  storiesService = inject(StoriesService);

  goBack() {
    this.navController.back();
  }

  roomsCount(story: Story): number {
    return story.Chats.length;
  }

  participantsCount(story: Story): number {
    return new Set(story.Story_Users.map(({ user }) => user.id)).size;
  }

  roomLabelKey(count: number): string {
    return count === 1 ? 'stories.list.roomsOne' : 'stories.list.roomsOther';
  }

  participantLabelKey(count: number): string {
    return count === 1
      ? 'stories.list.participantsOne'
      : 'stories.list.participantsOther';
  }
}
